import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { Select } from 'src/shared/components/select';
import { useStrategyItems } from './useStrategyItems';
export function RepeatStrategyForm({ className }) {
    const { setValue, getValues } = useFormContext();
    const strategyItems = useStrategyItems();
    const handleChange = (strategy) => {
        setValue('recurringSession.repeat.strategy', strategy, {
            shouldValidate: true
        });
    };
    return (_jsx(Select, { className: className, onChange: handleChange, children: strategyItems.map(({ label, value }) => (_jsx(Select.Item, { value: value, selected: value == getValues('recurringSession.repeat.strategy'), children: label }, value))) }));
}
